function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.1678 12.4997H15.8345V14.1663H14.1678V12.4997ZM14.1678 9.16634H15.8345V10.833H14.1678V9.16634ZM14.1678 5.83301H15.8345V7.49967H14.1678V5.83301ZM11.4512 5.83301L12.5012 6.53301V5.83301H11.4512Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.33398 2.5V3.75833L10.0007 4.86667V4.16667H17.5007V15.8333H14.1673V17.5H19.1673V2.5H8.33398Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.80898 4.75L12.5007 8.54167V17.5H0.833984V8.73333L6.80898 4.75ZM8.33398 15.8333H10.834V9.3L6.80898 6.74167L2.50065 9.48333V15.8333H5.00065V10.8333H8.33398V15.8333Z",
  fill: "white"
});

var SvgInstitution = function SvgInstitution(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInstitution, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/institution.63d97a70.svg";
export { ForwardRef as ReactComponent };